module.exports = __webpack_public_path__ + "media/index/how-it-works_mobile_1col_3rows_640x300_2x_tall-eb904ff4.png";